(function () {
    "use strict";

    angular
        .module("app.search")
        .controller("SearchController", SearchController);

    SearchController.$inject = [
        "$scope",
        "$cookies",
        "SearchService",
        "$timeout",
    ];

    function SearchController($scope, $cookies, SearchService, $timeout) {
        /* jshint validthis:true */
        var vm = this;
        vm.mouseleaved = true;
        vm.lastViewProducts = null;
        vm.filter = { Search: null };
        var timerId = 0;
        var oldSearchKey = null;
        vm.productLoader = false;

        function activate() {
            vm.searchHistory = ($cookies.get("searchHistory") || "").split(",");
            vm.searchHistory = vm.searchHistory.filter(function (flt) {
                return  flt != "";
              });
            vm.currentPageLink =
                window.location.origin + window.location.pathname;
            if (vm.currentPageLink.contains("SearchResult")) {
                var url = window.location.href;
                var urlSearchKey = $.Url.QueryString("SearchKey", url);
                if (urlSearchKey != vm.searchHistory[0]) {
                    vm.searchHistory[0] = urlSearchKey;
                }
                vm.filter.SearchKey = vm.searchHistory[0];
            }
        }

        function HidePriceData(SearchProductsResponse) {
            if (SearchProductsResponse) {
                if (SearchProductsResponse.Data) {
                    SearchProductsResponse.Data.forEach((element) => {
                        if (element.HidePrice === true) {
                            element.Price = undefined;
                            element.PriceWithDiscount = undefined;
                        }
                    });
                }
            }
        }

        vm.submitSearch = function () {
            if (vm.filter.SearchKey.length >= 0 && vm.filter.SearchKey!="") {
                vm.addSearchHistory(vm.filter.SearchKey);
            }
        };

        $scope.$watch("vm.filter.SearchKey", function (value) {
            waitForKey(value);

            function timer(value) {
                timerId = setTimeout(function (x) {
                    if (value && value.length > 0) {
                        oldSearchKey = value;
                        vm.productLoader = true;
                        SearchService.searchProduct(
                            vm.filter,
                            vm.cultures
                        ).then(function (response) {
                            HidePriceData(response);
                            vm.searchProductResult = response;
                            vm.productLoader = false;
                        });
                        if (vm.showRelatedCategoryInSearch) {
                            SearchService.searchCategory(
                                value,
                                vm.cultures
                            ).then(function (response) {
                                vm.searchCategoryResult = response;
                            });
                        }
                        if (vm.showRelatedBrandInSearch) {
                            SearchService.searchBrand(value, vm.cultures).then(
                                function (response) {
                                    vm.searchBrandResult = response;
                                }
                            );
                        }
                        if (vm.showRelatedGalleryInSearch) {
                            SearchService.searchGallery(
                                value,
                                vm.showRelatedGalleryInSearch,
                                vm.cultures
                            ).then(function (response) {
                                vm.searchGalleryResult = response;
                            });
                        }
                        if (vm.showRelatedSalesPointInSearch) {
                            SearchService.searchSalesPoint(
                                value,
                                vm.cultures
                            ).then(function (response) {
                                vm.searchSalesPointResult = response;
                            });
                        }
                    }
                }, 1000);
            }

            function waitForKey(value) {
                clearTimeout(timerId);
                timer(value);
            }
        });

        vm.addSearchHistory = function (value) {
            var foundIndex = vm.searchHistory.findIndex((x) => x == value);
            if (foundIndex != -1) {
                vm.searchHistory.splice(foundIndex, 1);
                vm.searchHistory.push(value);
            } else {
                vm.searchHistory.push(value);
            }

            vm.searchHistory = vm.searchHistory.reverse().slice(0, 5);
            $cookies.put("searchHistory", vm.searchHistory);
        };

        vm.clearLastViewProduct = function () {
            $cookies.remove("LastViewProduct");
            vm.lastViewProducts = {};
        };

        vm.focus = function (templateId) {
            vm.focused = true;
            vm.mouseleaved = false;
            vm.showSearchResult = true;
            vm.matchLastViewProduct = true;
            $(".arama .input-group").addClass("search-focused");
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                $("#" + templateId + " .arama").addClass(
                    "mobile-search-active"
                );
            }

            SearchService.getLastViewProducts(vm.cultures).then(function (
                response
            ) {
                var cookieItems = getCookieByName("LastViewProduct");
                if (cookieItems) {
                    cookieItems = cookieItems.split(",");
                    response.Data.find(function (item) {
                        if (cookieItems.find((x) => x === item.Code))
                            vm.matchLastViewProduct = false;
                    });
                    if (response.Data.length != cookieItems.length) {
                        HidePriceData(response);
                        vm.lastViewProducts = response;
                    }
                }
                if (vm.matchLastViewProduct) {
                    HidePriceData(response);
                    vm.lastViewProducts = response;
                }
            });
        };

        vm.blurSearch = function (templateId) {
            vm.focused = false;
            if (!vm.focused && vm.mouseleaved) {
                vm.showSearchResult = true;
            }
        };

        vm.mouseleaveSearch = function (templateId) {
            vm.mouseleaved = true;
            if (!vm.focused && vm.mouseleaved) {
                vm.showSearchResult = true;
            }
        };

        vm.clear = function (templateId, directClose) {
            vm.showSearchResult = false;
            vm.focused = false;
            vm.mouseleaved = true;
            vm.searchProductResult = null;
            vm.searchCategoryResult = null;
            vm.searchBrandResult = null;
            directClose ? (vm.filter.SearchKey = null) : vm.filter.SearchKey;
            $(".arama .input-group").removeClass("search-focused");
            $("#" + templateId + " .arama").removeClass("mobile-search-active");
            vm.focusOnSearch();
        };

        vm.clearSearchHistory = function () {
            $cookies.remove("searchHistory");
            vm.searchHistory = [];
        };

        vm.setSearch = function (history) {
            vm.filter.SearchKey = history;
        };

        vm.getMainPrice = function (product) {
            var price = product.Price;
            var priceWithDiscount = product.PriceWithDiscount;
            var defaultPrice = product.Price;
            if (product.Currency.Default == false) {
                if (priceWithDiscount != price) {
                    defaultPrice = priceWithDiscount * product.Currency.Rate;
                } else {
                    defaultPrice = price * product.Currency.Rate;
                }
            }
            return defaultPrice;
        };
        vm.getCalculatePrice = function (product, discount) {
            var price = product.Price;
            var priceWithDiscount = product.PriceWithDiscount;
            var defaultPrice = product.Price;
            if (discount == 1) {
                defaultPrice = priceWithDiscount * product.Currency.Rate;
            } else if (discount == 0) {
                defaultPrice = price * product.Currency.Rate;
            } else if (discount == 2) {
                defaultPrice =
                    product.CurrentDiscount.Amount * product.Currency.Rate;
            }
            return defaultPrice;
        };
        vm.toggleSearch = function () {
            vm.searchListOpen = !vm.searchListOpen;
            $("body").toggleClass("overflow-hidden", vm.searchListOpen);
            vm.focusOnSearch();
        };
        vm.focusOnSearch = function () {
            if (vm.searchListOpen) {
                setTimeout(function () {
                    $("#searchInputScreen").focus();
                }, 30);
            }
        };

        function getCookieByName(name) {
            return $cookies.get(name);
        }

        activate();
    }
})();
